import DataType from '../../Config/DataStructure';
import { SinglePlayOverviewDataType, SinglePlayPreviewDataType, SinglePlayStatsDataType } from '../../Config/GamePreviewDataType';
import CommonGamePreviewData from './CommonGamePreviewData';

enum EventType {
    TABLE_COUNT_CHANGED = 'TABLE_COUNT_CHANGED',
    PLAYING_TABLE_COUNT_CHANGED = 'PLAYING_TABLE_COUNT_CHANGED',
    REMAINING_TABLE_COUNT_CHANGED = 'REMAINING_TABLE_COUNT_CHANGED',
}

export default class SinglePlayGamePreviewData extends CommonGamePreviewData implements SinglePlayPreviewDataType {
    public static readonly EVENT_TYPE = { ...CommonGamePreviewData.EVENT_TYPE, ...EventType };
    // HACK
    protected _tableCount: number = 0;
    protected _remainingTableCount: number = 0;
    protected _playingTableCount: number = 0;

    constructor(hallID: number, gameID: string, playType: DataType.Enums.PlayType, data: SinglePlayOverviewDataType) {
        super(hallID, gameID, playType, data);
        this._tableCount = data.TableCount;
    }

    public get TableCount() {
        return this._tableCount;
    }
    protected set TableCount(value: number) {
        if (this._tableCount === value) {
            return;
        }
        this._tableCount = value;
        this.emit(SinglePlayGamePreviewData.EVENT_TYPE.TABLE_COUNT_CHANGED, this._tableCount);
    }

    public get playingTableCount() {
        return this._playingTableCount;
    }
    protected set playingTableCount(value: number) {
        if (this._playingTableCount === value) {
            return;
        }
        this._playingTableCount = value;
        this.emit(SinglePlayGamePreviewData.EVENT_TYPE.PLAYING_TABLE_COUNT_CHANGED, this._playingTableCount);
    }

    public get remainingTableCount() {
        return this._remainingTableCount;
    }
    protected set remainingTableCount(value: number) {
        if (this._remainingTableCount === value) {
            return;
        }
        this._remainingTableCount = value;
        this.emit(SinglePlayGamePreviewData.EVENT_TYPE.REMAINING_TABLE_COUNT_CHANGED, this._remainingTableCount);
    }

    public updateOverviewData(data: SinglePlayOverviewDataType) {
        this.TableCount = data.TableCount;
        super.updateOverviewData(data);
    }

    public updateStatsData(data: SinglePlayStatsDataType) {
        super.updateStatsData(data);
    }
}
